<template>
  <v-container fluid>
    <v-card class="ui-module-card ui-module-fade-in-up preaspirantes-shell" flat>
      <v-card-text>
        <v-row>
          <v-col cols="7" align="right">
            <TextButton
              class="secondary ui-module-btn-solid ui-module-fade-in-up py-y mt-4 px-8"
              rounded
              elevation="8"
              to="/profesionalizacion/registro_preaspirante"
            >
              Registrar aspirante <v-icon small class="ml-2">mdi-plus</v-icon>
            </TextButton>
          </v-col>
          <v-col cols="12" lg="5">
            <v-text-field
              class="ui-form-field mt-2"
              v-model="buscaPreaspirante"
              color="secondary"
              background-color="transparent"
              rounded
              filled
              hide-details
              placeholder="Buscar aspirantes..."
              aria-label="Buscar aspirantes"
              append-icon="mdi-magnify"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-data-table
              class="preaspirantes-table ui-module-table"
              :headers="headers"
              :items="filteredPreaspirantes"
              dark
              item-key="idPersonal"
              hide-default-footer
              disable-pagination
              dense
            >
              <template v-slot:[`item.nombreCompleto`]="{ item }">
                <span>{{ item.apaterno }} {{ item.amaterno }} {{ item.nombre }} {{ item.segundoNombre }}</span>
              </template>
              <template v-slot:[`item.acciones`]="{ item }">
                <v-tooltip bottom color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="error--text mx-1 ui-module-icon-action"
                      :to="{ name: 'archivarPreaspirante', params: { id: item.idPersonal } }"
                      icon
                      v-on="on"
                      v-bind="attrs"
                    >
                      <v-icon small>mdi-archive-arrow-down</v-icon>
                    </v-btn>
                  </template>
                  <span>Archivar preaspirante</span>
                </v-tooltip>
                <v-tooltip bottom color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="secondary--text mx-1 ui-module-icon-action"
                      :to="{ name: 'agendaCita', params: { id: item.idPersonal } }"
                      icon
                      v-on="on"
                      v-bind="attrs"
                    >
                      <v-icon small>mdi-calendar</v-icon>
                    </v-btn>
                  </template>
                  <span>Agendar cita de evaluación</span>
                </v-tooltip>
                <v-tooltip bottom color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="secondary--text mx-1 ui-module-icon-action"
                      :to="{ name: 'evaluacionMedica', params: { id: item.idPersonal } }"
                      icon
                      v-on="on"
                      v-bind="attrs"
                    >
                      <v-icon small>mdi-medical-bag</v-icon>
                    </v-btn>
                  </template>
                  <span>Realizar evaluación</span>
                </v-tooltip>
                <v-tooltip bottom color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="secondary--text mx-1 ui-module-icon-action"
                      :to="{ name: 'documentosPreaspirante', params: { id: item.idPersonal } }"
                      icon
                      v-on="on"
                      v-bind="attrs"
                    >
                      <v-icon small>mdi-file-account</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver expediente</span>
                </v-tooltip>
                <v-tooltip bottom color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="secondary--text mx-1 ui-module-icon-action"
                      :to="{ name: 'validaPreaspirante', params: { id: item.idPersonal } }"
                      icon
                      v-on="on"
                      v-bind="attrs"
                    >
                      <v-icon small>mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <span>Validar preaspirante</span>
                </v-tooltip>
              </template>
              <template v-slot:no-data>
                <div class="text-h6 justify-center" align="center">
                  No hay aspirantes registrados
                </div>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import TextButton from '@/components/base/TextButton.vue'

export default {
  components: {
    TextButton,
  },
  data() {
    return {
      buscaPreaspirante: '',
      headers: [
        { text: 'Nombre completo', value: 'nombreCompleto', sortable: false },
        { text: 'Acciones', value: 'acciones', sortable: false, align: 'center' },
      ],
    }
  },

  computed: {
    ...mapGetters('preaspirante', {
      preaspirantes: 'getPreaspirantes',
    }),

    filteredPreaspirantes() {
      const search = this.buscaPreaspirante.toLowerCase()
      return this.preaspirantes.filter((p) => {
        return (
          (p.nombre || '').toLowerCase().indexOf(search) >= 0 ||
          (p.segundoNombre || '').toLowerCase().indexOf(search) >= 0 ||
          (p.apaterno || '').toLowerCase().indexOf(search) >= 0 ||
          (p.amaterno || '').toLowerCase().indexOf(search) >= 0
        )
      })
    },
  },
}
</script>

<style scoped>
.preaspirantes-shell {
  min-height: calc(100vh - 64px);
  min-height: calc(100dvh - 64px);
}

/* Input de búsqueda */
::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(0, 210, 160, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  transition: all 0.3s ease !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(0, 210, 160, 0.45) !important;
}

::v-deep .ui-form-field input {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field input::placeholder {
  color: rgba(224, 224, 224, 0.5) !important;
}

::v-deep .ui-form-field .v-label,
::v-deep .ui-form-field .mdi-magnify {
  color: rgba(38, 222, 129, 0.75) !important;
}

/* Data Table */
::v-deep .preaspirantes-table.v-data-table {
  background: transparent !important;
  color: #e0e0e0 !important;
  border-radius: 12px;
  border: 1px solid rgba(0, 210, 160, 0.15);
  overflow: hidden;
}

::v-deep .preaspirantes-table > .v-data-table__wrapper {
  background: transparent !important;
}

::v-deep .preaspirantes-table > .v-data-table__wrapper > table {
  background: transparent !important;
}

::v-deep .preaspirantes-table > .v-data-table__wrapper > table > tbody {
  background: transparent !important;
}

::v-deep .preaspirantes-table > .v-data-table__wrapper > table > thead {
  background: rgba(0, 210, 160, 0.15) !important;
}

::v-deep .preaspirantes-table .v-data-table-header th {
  color: #26de81 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(0, 210, 160, 0.3) !important;
  padding: 16px !important;
  background: transparent !important;
}

::v-deep .preaspirantes-table tbody tr {
  transition: all 0.3s ease;
  background: transparent !important;
}

::v-deep .preaspirantes-table tbody tr:hover {
  background: rgba(0, 210, 160, 0.1) !important;
}

::v-deep .preaspirantes-table tbody td {
  color: #e0e0e0 !important;
  background: transparent !important;
  border-bottom: 1px solid rgba(0, 210, 160, 0.1) !important;
  padding: 12px 16px !important;
}

::v-deep .preaspirantes-table .v-data-table__empty-wrapper {
  background: transparent !important;
  color: rgba(224, 224, 224, 0.6) !important;
}

::v-deep .preaspirantes-table .text-h6 {
  color: #e0e0e0 !important;
  font-weight: 600;
  padding: 32px 16px;
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(26, 46, 36, 0.95) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 210, 160, 0.3);
  border-radius: 8px;
  color: #e0e0e0 !important;
  font-weight: 500;
  padding: 8px 12px;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(0, 210, 160, 0.4);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 210, 160, 0.6);
}

::v-deep .preaspirantes-shell.v-card {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
}

::v-deep .preaspirantes-shell.v-card:hover {
  transform: none !important;
  box-shadow: none !important;
}
</style>
